import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/EarlyAccess.css';
import '../assets/styles/LandingLayout.css';

const EarlyAccess = () => {
  const [copySuccess, setCopySuccess] = useState('');

  const emailAddress = "aimathstutorapp@gmail.com";
  const emailSubject = "Early Access Request - AI Maths Tutor";
  const emailBody = `Hi Nathan,

I'd like to request early access to AI Maths Tutor.

Name: [Your Name]
Email: [Your Email]
Location: [NSW/VIC/QLD/etc]
Year Level: [Year 11 Student/Parent/Teacher]
Textbook: [Cambridge/Pearson/Oxford/etc]

Why I'm interested:
[Brief description of how you'd use AI Maths Tutor]

Thanks!`;

  const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

  const copyEmailAddress = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy');
      setTimeout(() => setCopySuccess(''), 2000);
    }
  };

  return (
    <div className="early-access-page app-background-pattern">
      <div className="early-access-content">
        <div className="hero-section">
          <h1>Join the Beta</h1>
          <p className="hero-subtitle">
            AI Maths Tutor is in limited <span className="highlight-blue">beta</span>. Get early access and help shape the future of <span className="highlight-blue">math learning</span>.
          </p>
        </div>

        <div className="main-content">
          <div className="email-section">
            <h1>Request Free Early Access</h1>
            <p>Send us an <span className="highlight-blue">email</span> to get started:</p>
            
            <div className="email-container">
              <div className="email-address" onClick={copyEmailAddress}>
                {emailAddress}
                <button className="copy-btn" aria-label="Copy email address">
                  {copySuccess || '📋'}
                </button>
              </div>
            </div>

            <div className="action-buttons">
              <a href={mailtoLink} className="primary-btn">
                Send Email
              </a>
              <Link to="/" className="secondary-btn">
                Back to Home
              </Link>
            </div>
          </div>

          <div className="info-section">
            <div className="info-card">
              <h3>What to Include</h3>
              <ul>
                <li>Your name and email</li>
                <li>Location (NSW, VIC, etc.)</li>
                <li>Year level or role</li>
                <li>Current textbook</li>
                <li>How you'd use the tutor</li>
              </ul>
            </div>
            
            <div className="info-card">
              <h3>What You'll Get</h3>
              <ul>
                <li>Early access to the platform</li>
                <li>Direct feedback channel</li>
                <li>Special launch benefits</li>
                <li>Priority support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarlyAccess;